import Stack from '@mui/material/Stack';
import { type CssVarsTheme, styled, useTheme } from '@mui/material/styles';
import { SmileySad1 } from '../../streamlineRegularIcon/SmileySad1';
import { SmileySmile2 } from '../../streamlineRegularIcon/SmileySmile2';
import { RemoveCircle1 } from '../../streamlineSolidIcon/RemoveCircle1';
import { SmileySimpleSad1 } from '../../streamlineSolidIcon/SmileySimpleSad1';
import { SmileySimpleSmile2 } from '../../streamlineSolidIcon/SmileySimpleSmile2';
import { areYouOkContainerSize } from '../constants';

export type StatusIconKey =
  | 'ok'
  | 'okSelected'
  | 'needSupport'
  | 'needSupportSelected'
  | 'cancel';

type StatusIcon = {
  defaultText: string;
  textColor: string;
  icon: React.ReactElement | null;
  timerColor?: string;
};

const bigFontSize = `${areYouOkContainerSize + 2}px!important`;

const StyledContainer = styled(Stack)(({ theme }) => ({
  borderRadius: '50%',
  width: `${areYouOkContainerSize}px`,
  height: `${areYouOkContainerSize}px`,
  marginBottom: theme.spacing(1),
  justifyContent: 'center',
  alignItems: 'center',
}));

const StyledSmileySimpleSmile2 = styled(SmileySimpleSmile2)((props) => {
  const theme = props.theme as unknown as CssVarsTheme;
  return {
    color: (theme.vars || theme).palette.grey[900],
    height: bigFontSize,
  };
});

const StyledSmileySimpleSad1 = styled(SmileySimpleSad1)((props) => {
  const theme = props.theme as unknown as CssVarsTheme;
  return {
    color: (theme.vars || theme).palette.grey[900],
    height: bigFontSize,
  };
});

export const useIcons = (iconKey: StatusIconKey) => {
  const theme = useTheme() as CssVarsTheme;
  const { palette } = theme.vars;

  const icons: Record<StatusIconKey, StatusIcon> = {
    ok: {
      defaultText: 'I’m Ok',
      textColor: palette.success.darkest,
      icon: (
        <StyledContainer sx={{ backgroundColor: palette.success.main }}>
          <StyledSmileySimpleSmile2 />
        </StyledContainer>
      ),
      timerColor: palette.success.main,
    },
    okSelected: {
      defaultText: 'I’m Ok',
      textColor: palette.success.darkest,
      icon: (
        <StyledContainer>
          <SmileySmile2
            sx={{ color: palette.success.dark, height: bigFontSize }}
          />
        </StyledContainer>
      ),
    },
    needSupport: {
      defaultText: 'I Need Support',
      textColor: palette.orange.darkest,
      icon: (
        <StyledContainer sx={{ backgroundColor: palette.orange.main }}>
          <StyledSmileySimpleSad1 />
        </StyledContainer>
      ),
      timerColor: palette.orange.main,
    },
    needSupportSelected: {
      defaultText: 'I Need Support',
      textColor: palette.orange.darkest,
      icon: (
        <StyledContainer>
          <SmileySad1
            sx={{ color: palette.orange.dark, height: bigFontSize }}
          />
        </StyledContainer>
      ),
    },
    cancel: {
      defaultText: 'Cancel',
      textColor: palette.text.primary,
      icon: (
        <StyledContainer>
          <RemoveCircle1
            sx={{ color: palette.grey[300], height: bigFontSize }}
          />
        </StyledContainer>
      ),
    },
  };

  return icons[iconKey];
};
